module.exports = __webpack_public_path__ + "assets/images/USD005.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/USD005.png
// module id = 1447
// module chunks = 1